import React from 'react'

import {
  COMPANY_NAME,
  COMPANY_ADDRESS,
  CONTACT_EMAIL,
  CONTACT_PHONE,
  CONTACT_PHONE_DISPLAY,
} from '../../constants'

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-[#1A1514] text-white py-10">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-6 mb-6">
          {/* Column 1 - Logo & Description */}
          <div>
            <div className="flex items-center gap-2 font-bold text-base mb-3">
              <img
                src="/logo.svg"
                alt="LeanC logo"
                className="w-25 h-10 invert"
              />
            </div>
            <p className="text-xs sm:text-sm text-white/75">
              Onafhankelijk IT-advies voor ondernemers in Rotterdam. Eerlijk,
              direct, geen gedoe.
            </p>
          </div>

          {/* Column 2 - Quick Links */}
          <div>
            <h3 className="font-bold text-sm mb-3 text-white">Snelle links</h3>
            <ul className="space-y-1.5 text-xs sm:text-sm">
              <li>
                <a
                  href="#diensten"
                  className="text-white/75 hover:text-brand-accent transition-colors"
                >
                  Diensten
                </a>
              </li>
              <li>
                <a
                  href="#werkwijze"
                  className="text-white/75 hover:text-brand-accent transition-colors"
                >
                  Werkwijze
                </a>
              </li>
              <li>
                <a
                  href="#contact"
                  className="text-white/75 hover:text-brand-accent transition-colors"
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Column 3 - Contact Info */}
          <div>
            <h3 className="font-bold text-sm mb-3 text-white">Contact</h3>
            <ul className="space-y-1.5 text-xs sm:text-sm text-white/75">
              <li>{COMPANY_ADDRESS}</li>
              <li>
                <a
                  href={`mailto:${CONTACT_EMAIL}`}
                  className="hover:text-brand-accent transition-colors"
                >
                  {CONTACT_EMAIL}
                </a>
              </li>
              <li>
                <a
                  href={`tel:${CONTACT_PHONE}`}
                  className="hover:text-brand-accent transition-colors"
                >
                  {CONTACT_PHONE_DISPLAY}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-white/75 text-xs">
            © {currentYear} {COMPANY_NAME}. Alle rechten voorbehouden.
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
